import { Container } from 'components/Container';
import React, { useState } from 'react';
import styles from './LastenAreenaInfo.module.scss';
import { DSNotification } from 'components/DSNotification';
import { useRouter } from 'next/router';
import { useTranslation } from 'hooks/useTranslation';

export const LastenAreenaInfo: React.FC = () => {
  const [isHidden, setHidden] = useState(false);
  const router = useRouter();
  const t = useTranslation();

  const close = () => {
    setHidden(true);
    router.replace(stripQueryFromPath(router.asPath), undefined, {
      shallow: true,
    });
  };

  return (
    <div className={styles.root} hidden={isHidden}>
      <Container>
        <DSNotification
          state="text"
          type="info"
          title={t('lastenareena_end_title_web')}
          subtitle={t('lastenareena_end_description_web')}
          close={close}
          theme="light"
        />
      </Container>
    </div>
  );
};

function stripQueryFromPath(path: string): string {
  return path.split('?')[0]!;
}
